import type { UserEntry } from '../api';
import type { MongoAbility } from '@casl/ability';

export interface UserFormData {
  email: string;
  role: string;
  projects: number[];
}
export interface CreateUserDTO extends Omit<UserEntry, 'id' | 'projects'> {
  projects_ids: number[];
}

export interface UpdateUserDTO extends Omit<UserEntry, 'id' | 'projects'> {
  projects_ids: number[];
}

export type SortValue = 'role' | 'email';

export enum Subjects {
  RULES = 'Rules',
  METRICS = 'Metrics',
  EMERGENCY = 'Emergency',
  USERS = 'Users',
}
export enum RuleAbilities {
  READ = 'read',
  UPDATE = 'update',
  DUPLICATE = 'duplicate',
  CHANGE_STATUS = 'change_status',
}
export enum MetricAbilities {
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  CREATE = 'create',
  ADD_TO_GROUP = 'add_to_group',
  REMOVE_FROM_GROUP = 'remove_from_group',
}

export enum EmergencyAbilities {
  TOGGLE = 'toggle',
}

export interface ProjectScopedSubject {
  project_id: number;
}

type AppAbilities =
  | [EmergencyAbilities | 'manage', Subjects.EMERGENCY]
  | [MetricAbilities | 'manage', Subjects.METRICS | ProjectScopedSubject]
  | [RuleAbilities | 'manage', Subjects.RULES | ProjectScopedSubject]
  | ['manage' | 'create' | 'delete', Subjects.USERS];

export type AppAbility = MongoAbility<AppAbilities>;
